var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewShelf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.096,
    height: 40,
    viewBox: "0 0 53.096 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(-690 -384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(690 384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box-fragile-svgrepo-com",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M50.491,51.307H2.6A2.536,2.536,0,0,0,0,53.761V88.853a2.536,2.536,0,0,0,2.6,2.454H50.491a2.536,2.536,0,0,0,2.6-2.454V53.761A2.536,2.536,0,0,0,50.491,51.307Zm.942,37.546a.917.917,0,0,1-.942.888H2.6a.917.917,0,0,1-.942-.888V53.761a.917.917,0,0,1,.942-.888H50.491a.917.917,0,0,1,.942.888V88.853Z",
    transform: "translate(0 -51.307)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(698 395.071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M37.007,81.5H33.622V67.889a.752.752,0,0,0-.752-.752H28.958V64.73a.752.752,0,0,0-.752-.752H23.543a.752.752,0,0,0-.752.752V70H19.632v-3.31a.752.752,0,0,0-.752-.752H14.968V63.752A.752.752,0,0,0,14.216,63H9.553a.752.752,0,0,0-.752.752v2.181H4.889a.752.752,0,0,0-.752.752V81.5H.752A.752.752,0,0,0,0,82.255v2.708a.752.752,0,0,0,.752.752H3.911v4.814a.752.752,0,1,0,1.5,0V85.715H37.007a.752.752,0,0,0,.752-.752V82.255A.752.752,0,0,0,37.007,81.5ZM28.958,68.641h3.159V81.5H28.958Zm-4.663-3.159h3.159V81.5H24.295ZM19.632,71.5h3.159v10H19.632Zm-4.663-4.062h3.159V81.5H14.968ZM10.3,64.5h3.159v17H10.3ZM5.641,67.438H8.8V81.5H5.641ZM36.254,84.211H1.5v-1.2h34.75Z",
    transform: "translate(0 -63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M430.752,379a.752.752,0,0,0-.752.752v3.009a.752.752,0,0,0,1.5,0v-3.009A.752.752,0,0,0,430.752,379Z",
    transform: "translate(-397.657 -355.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M86.752,140a.752.752,0,0,0-.752.752v.677a.752.752,0,1,0,1.5,0v-.677A.752.752,0,0,0,86.752,140Z",
    transform: "translate(-79.531 -134.208)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M86.752,185a.752.752,0,0,0-.752.752v6.769a.752.752,0,1,0,1.5,0v-6.769A.752.752,0,0,0,86.752,185Z",
    transform: "translate(-79.531 -175.824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M272.752,192a.752.752,0,0,0-.752.752v.416a.752.752,0,1,0,1.5,0v-.416A.752.752,0,0,0,272.752,192Z",
    transform: "translate(-251.541 -182.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M272.752,232a.752.752,0,0,0-.752.752v3.234a.752.752,0,1,0,1.5,0v-3.234A.752.752,0,0,0,272.752,232Z",
    transform: "translate(-251.541 -219.288)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewShelf);
export default __webpack_public_path__ + "static/media/view-shelf.0674f6adf06ad230893380385938bd3a.svg";
export { ForwardRef as ReactComponent };